import React, { useState } from "react";

export default function FAQPopupGrowth({eleRef}) {
    
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "What is a growth chart?",
            answer:"A growth chart is a tool that is used to evaluate your baby’s growth rate and find out whether or not your baby is growing as per the standard growth rate. The rate of growth differs in boy and girl babies, which is why they also have separate growth charts to track this difference in growth patterns. <br/><br/> Growth patterns differ across babies. However, growth rate is a useful metric to track whether or not your baby is healthy. It is generally seen that children who are growing as per the expected rate, and whose height and weight are well matched, are healthier. It is important to understand that this does not mean their height and weight are the same. It simply means that such children gain weight in proportion to their height and gender."
        },
        {
            question: "What does a growth chart measure?",
            answer:`A growth chart tracks your baby’s growth according to three parameters: <ul style="listStyle: circle !important, paddingLeft : 5%"> <li style="borderBottom: none">Height </li><li>Weight </li> <li>Head circumference </li> </ul> In order to assess your baby’s growth, you need to measure/get these parameters measured by your baby’s paediatrician. Once you have the measurements, enter these numbers into your baby’s growth chart. These numbers need to be tracked over a period of time. These measurements will reflect whether or not your baby is growing as per the standard/expected growth rate. It is also advised to discuss these numbers with your paediatrician who will help ensure that your little one’s growth is in accordance to the standard/normal curve.`
        },
        {
            question: "What references do you use for the standard growth chart?",
            answer: `<span className="M14_9e">A. </span> We use the child growth standards published by the World Health Organization (WHO), which describe the optimal growth for healthy, breastfed children. <p id="childgrowth"> <a target="_self" style="color: #156cf4!important" className="ui-link" href="http://www.who.int/childgrowth/standards">http://www.who.int/childgrowth/standards.</a> </p>`
        },
        {
            question: "What is the ideal range in the growth chart?",
            answer:"The ideal range in the growth chart has been defined as per the Percentiles data provided by the WHO. Percentiles are very commonly used clinical metrics to analyse the growth patterns of children. This is how a percentile works - it ranks your child’s position by showing the percentage of the reference population that your child would equal/exceed. For example: if your child’s weight is in the 75th percentile, this means her weight is more than 75 children and less than 25 children when compared to 100 children in her age group. <br/> <br/> The WHO provides percentile range from 3rd to 97th percentile for each stage of baby's growth starting from birth to 5 years. For example: for a 1-month-old baby girl, 3rd and 97th percentile weight measurements are 3.2 kg and 5.4 kg respectively. So, the ideal weight range for a 1-month-old baby girl is 3.2-5.4 kg."
        },
        {
            question:"What if my baby’s growth curve doesn't follow the chart?",
            answer:"If you notice temporary fluctuations in your baby’s growth curve, don't get too anxious. This is quite normal. If your baby is going through a growth spurt, the growth chart might display an upsurge. Similarly, if your baby has just been through a spate of illness, the chart might indicate a temporary down. <br/><br/> However, if your doctor notices that your baby is not keeping up with her curve over time, he will conduct a thorough check to diagnose if something is preventing your baby from growing optimally. <br/> <br/> Growth charts are effective screening tools to see if your child’s health and overall growth require further investigation. However, they cannot be reliably used to diagnose a problem. This is because growth charts can sometimes indicate a problem that doesn’t really exist, or overlook a problem that should have been identified. <br/><br/> paediatrician before taking any action or making any modifications to her feeding, sleeping habits, physical activities, etc. Your doctor will be able to ascertain if there really is anything to worry about and also give you the reassurance as well as next steps for action to be taken."
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleCancel= ()=>{
        eleRef.closefaqPopup();
    }

    return (

        <div className="showFaq-overlay-growth" style={{display: "none"}}>
            <div className="showFaqmodal">

                {/* Header */}
                <div className="faq_title">
                    <button className="faq-back-btn" onClick={handleCancel}>
                        <img
                            src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png"
                            alt="back"
                        />
                    </button>

                    <span>Frequently Asked Questions</span>
                </div>

                {/* Body */}
                <div className="accordion">
                    {faqData.map((item, index) => (
                        <div
                            className={`duedate-faq ${
                                activeIndex === index ? "faq-active" : ""
                            }`}
                            key={index}
                        >
                            <div
                                className="accordion-header"
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className="faq-question">
                                    <span className="question-label">Q.</span>
                                    <span className="M17_42">
                                        {item.question}
                                    </span>
                                </div>

                                <span
                                    className={
                                        activeIndex === index
                                            ? "arrow rotate"
                                            : "arrow"
                                    }
                                >
                                    <img
                                        src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                        alt="dropdown"
                                    />
                                </span>
                            </div>

                            {activeIndex === index && (
                                <div className="accordion-body">
                                    <div className="schema-answer">
                                        <span className="answer-label">A.</span>

                                        <span
                                            className="R14_61"
                                            dangerouslySetInnerHTML={{
                                                __html: item.answer,
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
};

